<!--
    校区信息
    功能：展示当前校区信息
-->
<template>
  <div
    v-loading="loading"
    class="department_info">
    <el-button
      v-if="this.user.id === this.school.main_id"
      class="edit_btn"
      type="primary"
      icon="el-icon-edit"
      size="mini"
      @click="edit">编辑</el-button>
    <el-form
      ref="form"
      :model="form"
      label-width="110px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="校区名称：">{{ form.name }}</el-form-item>
          <el-form-item label="品牌名称：">{{ form.brand }}</el-form-item>
          <!--          <el-form-item label="总校代付：">{{ form.is_pil === 1 ? '开启' : '关闭' }}</el-form-item>-->
          <el-form-item label="所属类目：">{{ form.school_category_name }}</el-form-item>
          <el-form-item label="所在地区：">{{ form.province }} {{ form.city }} {{ form.area }} {{ form.street }}</el-form-item>
          <el-form-item label="校长：">{{ form.user_name }}</el-form-item>
          <el-form-item label="校长电话：">{{ form.user_mobile }}</el-form-item>
          <el-form-item label="邮箱：">{{ form.email }}</el-form-item>
          <el-form-item label="入驻时间：">{{ data.created_at }}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="logo：">
            <img
              :src="form.logo"
              class="image"
              alt="">
          </el-form-item>
          <el-form-item label="公司全称：">{{ form.company_name }}</el-form-item>
          <el-form-item
            label="统一社会代码："
            class="company">{{ form.company_code }}</el-form-item>
          <el-form-item label="营业执照：">
            <img
              :src="form.company_license_img"
              class="image"
              alt="">
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import baseUrl from '../../utils/api';

export default {
  name: 'IndexInfo',
  data() {
    return {
      loading: false,
      data: {},
      form: {},
    };
  },
  computed: {
    school() {
      return this.$store.state.choicesSchool;
    },
    user() {
      return this.$store.state.mainUser;
    },
  },
  created() {
    this.loading = true;
    this.$http.get(`${baseUrl}/api/clients/${this.school.id}`)
      .then((res) => {
        console.log('校长信息', res);
        this.loading = false;
        this.data = res;
        this.form = res.review_last;
      })
      .catch((err) => {
        this.loading = false;
        this.$message.error(err.message);
      });
  },
  methods: {
    edit() {
      this.$router.push(`/index/${this.data.id}`);
    },
  },
};
</script>

<style scoped lang="scss">
.department_info {
  position: relative;
  .edit_btn {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 9;
  }
  .image {
    width: 200px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Main/info.vue